import React from 'react';
import { useLoginClientContext } from './context';
import { FieldsBuilder } from '../../../../../../libs/uiKit/fieldsBuilder';
import Button from '../../../../../../libs/uiKit/button';

const LoginClientUi: React.FC = () => {
	const { form, loginHandler, isLoadingLogin } = useLoginClientContext();

	return (
		<form onSubmit={loginHandler}>
			<FieldsBuilder {...form} />
			<Button appearance='filled' type='submit' isLoading={isLoadingLogin}>
				Войти
			</Button>
		</form>
	);
};

export default React.memo(LoginClientUi);
